module.exports = __webpack_public_path__ + "static/media/bg_9_and_10_flag.760d3bc8.png";